import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Chat = (props) => (
  <Icon viewBox="0 0 15 14" {...props}>
    <g>
      <title>chat</title>
      <g fill="currentColor" fillRule="evenodd">
        <path d="M0 0v11h4v3h1l4-3h6V0H0zm14 10H9l-4 3v-3H1V1h13v9z" />
        <path d="M4 3h7v1H4V3zM4 5h7v1H4V5zM4 7h7v1H4V7z" />
      </g>
    </g>
  </Icon>
);
/*eslint-enable */

export default Chat;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Chat.js